export enum ContentItemType {
  OpenLetter = 1,
  Forum = 2,
}
